export type FeedbackType = "bug" | "feature" | "general" | "pnl" | "liquidity";

export interface FeedbackPayload {
  type: FeedbackType;
  message: string;
  email?: string;
  telegram?: string;
  pageUrl: string;
  walletAddress?: string;
  timestamp: string;
  campaignId?: string;
  campaignName?: string;
}

export interface FeedbackFormData {
  type: FeedbackType;
  message: string;
  email: string;
  telegram: string;
  campaignId: string;
}

export const FEEDBACK_TYPE_CONFIG: Record<
  FeedbackType,
  {
    emoji: string;
    label: string;
    placeholder: string;
    color: number; // Discord embed color
  }
> = {
  bug: {
    emoji: "🐛",
    label: "Bug",
    placeholder: "What went wrong? Steps to reproduce help us fix it faster...",
    color: 0xf44335, // Red
  },
  feature: {
    emoji: "💡",
    label: "Feature",
    placeholder: "What would you love to see? How would it help you?",
    color: 0xa6fb74, // Green (cede-success)
  },
  general: {
    emoji: "💬",
    label: "Feedback",
    placeholder: "Tell us what you think... We read every message!",
    color: 0x5ea6ff, // Blue (cede-primary)
  },
  pnl: {
    emoji: "📊",
    label: "PnL",
    placeholder: "Tell us about any PnL calculation issues or discrepancies...",
    color: 0xffa726, // Orange
  },
  liquidity: {
    emoji: "💧",
    label: "Liquidity issues",
    placeholder: "Describe the liquidity problem you're experiencing...",
    color: 0x00bcd4, // Cyan
  },
};

export const ATTENTION_MESSAGES: [string, ...string[]] = [
  "Got ideas? Share 'em!",
  "Help us improve!",
  "Bug spotted? Tell us!",
  "What would make this better?",
];
